import { PositionType, SizeType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { MovieClip } from '@play-co/timestep-core/ui';
import { getMatch2AssetPath } from '../../util/assets';
import { Container } from '../../../odie';
import { ColorId } from '../../defs/block';

export type HatBreakEffectOptions = {
  position: PositionType;
  size: SizeType;
  color: ColorId;
};

/*
  Hat break effect
*/
export class HatBreakEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly position: PositionType;
  private readonly color: ColorId;
  private readonly size: SizeType;

  constructor(scene: GameScene, options: HatBreakEffectOptions) {
    this.scene = scene;
    this.position = options.position;
    this.size = options.size;

    this.color = options.color;
  }

  public async execute() {
    // Wait only a frame, do not wait for the whole animation.
    await waitAFrame();

    // Play the animation.
    this._animate();
  }
  private async _animate() {
    // Create movie clip.
    const animation = new MovieClip({
      url: getMatch2AssetPath('fx.hat'),
      ...this.position,
    });

    // Spawn the movie clip as an overlay entity.
    const entity = spawnOverlayEntity(
      this.scene,
      this.position,
      this.size,
      () => new Container(animation),
    );

    // Play the animations
    await animation.playAsync(
      `box_break_${this.color === 'all' ? 'neutral' : this.color}_anim`,
    );
    await animation.playAsync('box_explosion');

    // Despawn overlay entity.
    despawnOverlayEntity(this.scene, entity);
  }
}
